import React, { useContext } from 'react';
import { observer } from 'mobx-react';

import { AuthContext } from 'core/components/auth';
import { FormField } from 'core/components/form';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { withToast } from 'core/components/toast';
import { useStore } from 'core/store/store.mobx';

import useStyles from '../footer.styles';

// Why the standard Update footer is firing, so we can tell the agent what
// "Update Offer Price" will actually do (#30230 follow-up). 'stale' = the offer's
// pricing is out of date (rate control date 1-29 days old) and updating re-rates
// it to today; 'dirty' = the agent changed offer details and updating applies those
// edits; 'both' = stale AND dirty, so updating does both at once (re-rate + apply
// edits) — call this out so the agent isn't surprised that their edits also land.
// We deliberately avoid the internal term "rate control date" in the copy —
// agents think in terms of the offer's price being current, not the RCD field.
const UpdateReasonCopy = {
  stale: "This offer's pricing is out of date — updating will recalculate it with today's rates.",
  dirty: 'Updating will apply the changes you made to this offer.',
  both: "This offer's pricing is out of date — updating will apply your changes and recalculate it with today's rates."
};

const UpdateOffer = observer(({ onUpdate, updateReason }) => {
  const { offer: store } = useStore();
  const classes = useStyles();

  const session = useContext(AuthContext);
  const showOverrideCheckbox = !session.isAgency && session.username !== store.offer?.quote?.rep;

  const subtitle = updateReason ? UpdateReasonCopy[updateReason] : null;

  return (
    <>
      <div className={classes.titleContainer}>
        <Label className={classes.title} type="subtitle">
          Update Offer
        </Label>
        {subtitle && (
          <Label className={classes.subtitle} type="subtitle">
            {subtitle}
          </Label>
        )}
      </div>
      <div>
        {showOverrideCheckbox && (
          <FormField
            mode="light"
            name="dontOverwriteRep"
            label="Don't overwrite rep"
            type="checkbox"
            className={classes.checkbox}
          />
        )}
        <Button
          onClick={onUpdate}
          disabled={store.loading}
          loading={store.loading}
          variant="contained"
          color="primary"
          className={classes.btn}
        >
          <Label className={classes.btnLabel}>Update Offer Price</Label>
        </Button>
      </div>
    </>
  );
});
export default withToast(UpdateOffer);
